export const REFERENCIA_COMPROBANTES = [
  {
    deuda_categoria_id: 'CSSFD',
    deuda_tipo_id: 'FD',
    descripcion: 'Comprobante de fondo distributivo',
    referencia: 150,
  },
  {
    deuda_categoria_id: 'CSSPCTA',
    deuda_tipo_id: 'PCTA',
    descripcion: 'Comprobante de pago a cuenta',
    referencia: 103,
  },
  {
    deuda_categoria_id: 'CSSPP',
    deuda_tipo_id: 'DLT',
    descripcion: 'Diferencia generada por Lectura Temprana',
    referencia: 810,
  },
  {
    deuda_categoria_id: 'CSSPP',
    deuda_tipo_id: 'PPAPO',
    descripcion: 'Plan de Pago de Aportes',
    referencia: 200,
  },
  {
    deuda_categoria_id: 'CSSPP',
    deuda_tipo_id: 'PPINS',
    descripcion: 'Plan de Pago Inspecciones',
    referencia: 100,
  },
  {
    deuda_categoria_id: 'CSSPP',
    deuda_tipo_id: 'PPCDJ',
    descripcion: 'Plan de Pago Control Pago DJ',
    referencia: 120,
  },
  {
    deuda_categoria_id: 'CSSPP',
    deuda_tipo_id: 'PPCCF',
    descripcion: 'Plan de Pago Control Pago DJ - C.F.',
    referencia: 130,
  },
  {
    deuda_categoria_id: 'CSSPP',
    deuda_tipo_id: 'PPFDI',
    descripcion: 'Plan de Pago Fondo Distributivo',
    referencia: 140,
  },
  {
    deuda_categoria_id: 'CSSPP',
    deuda_tipo_id: 'CLCSEJ',
    descripcion: 'Consolidación Aportes Lectura CS  Ext.Juris.',
    referencia: 680,
  },
  {
    deuda_categoria_id: 'CSSPP',
    deuda_tipo_id: 'CLCS',
    descripcion: 'Consolidación a partir de Lect. CS',
    referencia: 670,
  },
  {
    deuda_categoria_id: 'CSSPP',
    deuda_tipo_id: 'C550EJ',
    descripcion: 'Consolidación R550E Vencidos e Impagos Ext. Juris.',
    referencia: 700,
  },
  {
    deuda_categoria_id: 'CSSPP',
    deuda_tipo_id: 'C550',
    descripcion: 'Consolidación R550E Vencidos e Impagos',
    referencia: 690,
  },
  {
    deuda_categoria_id: 'PREST',
    deuda_tipo_id: 'PREST',
    descripcion: 'Cuotas Préstamos',
    referencia: 400,
  },
  {
    deuda_categoria_id: 'SALUD',
    deuda_tipo_id: 'AFILADH',
    descripcion: 'Afiliados Adherentes de la Caja de Seguridad Social',
    referencia: 300,
  },
  {
    deuda_categoria_id: 'SALUD',
    deuda_tipo_id: 'UINDS',
    descripcion: 'Uso Indebido de Salud de la Caja de Seguridad Social',
    referencia: 320,
  },
]
